<app-loading *ngIf="contentReady"></app-loading>
<div class="container-fluid p-0">
  <div>


    <div class="col-12 col-sm-12 main-content">
      <div class="container-fluid mb-4">
        <div class="categoryContainer">

       <div class="col-12">
            <button routerLink="/createpricelist" style="margin-left: 0;" class="first-btn btn btn-primary">
          رسوم الجامعات
            </button>
            <!-- <button (click)="exportToExcel()" class="btn first-btn btn-primary">
              {{ "export to excel" | translate }}
            </button> -->
            
          <button (click)="getAllClients(10, 1)" style="margin-left: 0;" class="first-btn btn btn-primary">
              {{ 'refresh' | translate }}
            </button>
            <div class="input-group mb-3">
              <input type="text" class="form-control" [(ngModel)]="searchKey"
                placeholder="ابحث باسم الجامعة" aria-label="Recipient's username"
                aria-describedby="basic-addon2">
              <div class="input-group-append">
                <button class="btn btn-outline-secondary" (click)="search()" type="button">{{ 'Search' | translate
                  }}</button>
              </div>
            </div>

<br>
<div *ngIf="sarPrice">
  سعر الريال السعودي اليوم: {{ sarPrice | number:'1.2-2' }} جنيه
</div>

          </div>
        </div>
        <div>
          <table mat-table id="Clients" [dataSource]="dataSource" class="mat-elevation-z8">

            <ng-container matColumnDef="id">
              <th mat-header-cell *matHeaderCellDef>م</th>
              <td mat-cell *matCellDef="let el">{{ el.id }}


              </td>
            </ng-container>

            <ng-container matColumnDef="university_name">
              <th mat-header-cell *matHeaderCellDef>اسم الجامعة</th>
              <td mat-cell *matCellDef="let el">{{ el.university_name }}

              </td>
            </ng-container>

            <ng-container matColumnDef="fees">
              <th mat-header-cell *matHeaderCellDef>الرسوم</th>
              <td mat-cell *matCellDef="let el">{{ el.fees }}</td>
            </ng-container>


            <ng-container matColumnDef="options">
              <th mat-header-cell *matHeaderCellDef> </th>
              <td mat-cell *matCellDef="let element">

                <div class="dropdown">
                  <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton1"
                    data-bs-toggle="dropdown" aria-expanded="false">
                    <i class="fa-solid fa-ellipsis-vertical"></i>
                  </button>
                  <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                    <li><a class="dropdown-item" (click)='edit(element)'>
                        {{ "Edit" | translate }} </a></li>


                    <li><a class="dropdown-item" (click)='delete(element.id)'>{{ "Delete" | translate }}</a></li>

                </ul>
                </div>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>


        <div class="row">
          @if (noData) {
          <app-nodata></app-nodata>
          }
        </div>
      </div>
    </div>
  </div>
</div>